var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyTerminated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.109,
    height: 67.541,
    viewBox: "0 0 49.109 67.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hmmm_",
    "data-name": "Hmmm?",
    transform: "translate(-949.601 -389.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M15582,10968.475s22.325-10.549,43.644,5.721",
    transform: "translate(-14629.736 -10519.614)",
    fill: "none",
    stroke: "#58299c",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(957 413)",
    fill: "#58299c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(979 413)",
    fill: "#58299c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M-1-2.832H.558V-3.7a2.565,2.565,0,0,0,2.124-2.34,2.446,2.446,0,0,0-2.7-2.352,3.7,3.7,0,0,0-2.82,1.3L-1.83-6.06A2.071,2.071,0,0,1-.318-6.8c.732,0,1.2.432,1.2.936C.882-5.292.1-4.848-1-4.8ZM-.222.144A1.1,1.1,0,0,0,.846-.972,1.086,1.086,0,0,0-.222-2.04,1.1,1.1,0,0,0-1.338-.972,1.114,1.114,0,0,0-.222.144Z",
    transform: "translate(971.676 398.346) rotate(1)",
    fill: "#58299c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M-1.5-4.248H.837v-1.3a3.848,3.848,0,0,0,3.186-3.51c0-2.034-1.656-3.528-4.05-3.528a5.552,5.552,0,0,0-4.23,1.944L-2.745-9.09A3.107,3.107,0,0,1-.477-10.206c1.1,0,1.8.648,1.8,1.4,0,.864-1.17,1.53-2.826,1.6ZM-.333.216a1.645,1.645,0,0,0,1.6-1.674,1.629,1.629,0,0,0-1.6-1.6,1.657,1.657,0,0,0-1.674,1.6A1.671,1.671,0,0,0-.333.216Z",
    transform: "translate(978.352 403.061) rotate(13)",
    fill: "#58299c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M-1.5-4.248H.837v-1.3a3.848,3.848,0,0,0,3.186-3.51c0-2.034-1.656-3.528-4.05-3.528a5.552,5.552,0,0,0-4.23,1.944L-2.745-9.09A3.107,3.107,0,0,1-.477-10.206c1.1,0,1.8.648,1.8,1.4,0,.864-1.17,1.53-2.826,1.6ZM-.333.216a1.645,1.645,0,0,0,1.6-1.674,1.629,1.629,0,0,0-1.6-1.6,1.657,1.657,0,0,0-1.674,1.6A1.671,1.671,0,0,0-.333.216Z",
    transform: "translate(965.665 403.131) rotate(-16)",
    fill: "#58299c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyTerminated);
export default __webpack_public_path__ + "static/media/SurveyTerminated.81f054a3.svg";
export { ForwardRef as ReactComponent };